'use client';

import { useCallback } from 'react';

export function ScrollToSectionButton({
  targetId,
  label,
  testId,
}: {
  targetId: string;
  label: string;
  testId?: string;
}) {
  const handleClick = useCallback(() => {
    const el = document.getElementById(targetId);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }, [targetId]);

  return (
    <button
      data-testid={testId}
      onClick={handleClick}
      className="desktop:block bg-theme-primary hover:bg-theme-primary-hover mt-auto hidden w-fit cursor-pointer rounded-lg p-4 text-base font-normal text-white"
    >
      {label}
    </button>
  );
}
